import * as z from "zod";

export const setAddressVerified = {
  name: "setAddressVerified" as const,
  input: z.object({
    groupIds: z.array(z.string()).min(1).max(500),
    verified: z.boolean(),
  }),
  output: z.object({ updatedCount: z.number() }),
};
